<script lang="ts">
	import { createEventDispatcher } from 'svelte';

	import { actionInterpretator } from '../../helpers/scene_actions_to_ui';
	import type { DeviceActionUI } from '../../../../types/DeviceActionUI';
	import type { NotificationActionUI } from '../../../../types/NotificationActionUI';
	import SingleRowViewWithControls from './SingleRowViewWithControls.svelte';
	import { extract_actions_variables } from './extract_actions_variables';
	import type { SceneActionUI } from '../../../../types/SceneActionUI';
	import type { GroupActionUI } from 'src/types/GroupActionUI';

	import { Stack, Label } from '@Shelly/shelly-design-system';

	export let element, //only action types will be here, but its possible to be do or [do, delay], [delay, do]
		ind = -1,
		type: 'action' = 'action';

	const dispatch = createEventDispatcher();
	let msg_type = element.msg_type,
		purpose =
			element._gui_type ||
			element._gui_purpose ||
			element?.do?.blk[0]?._gui_type ||
			element?.do?.blk[0]?._gui_purpose ||
			undefined;

	if (element.do !== undefined && element.wait !== undefined) {
		//if there is do => it is a delay action, stupid, but in other way we miss it
		let copyDelay = { delay: element.wait, units: element.units };
		element = { ...element.do.blk[0], ...copyDelay };
	}

	let translated: NotificationActionUI | DeviceActionUI | GroupActionUI | SceneActionUI | undefined =
		actionInterpretator(purpose, element, msg_type);

	const { title, subtitle, labelList, actionList, withLabelList, avatar, description } =
		extract_actions_variables(translated);

	const handle_click = () => {
		console.log('element clicked - will display modal with action description');
	};
</script>

<SingleRowViewWithControls
	{element}
	{withLabelList}
	{labelList}
	{avatar}
	{title}
	{subtitle}
	{description}
	on:click={() => handle_click()}
	on:edit={() => dispatch('edit', { ind, type })}
	on:delete={() => dispatch('delete', { ind, type })}
/>

{#if actionList && actionList.length > 0}
	<Stack gap="s" class="mt-s">
		{#each actionList as { icon, name }}
			<Label class="width-full justify-content-start" {icon} value={name} size="s" />
		{/each}
	</Stack>
{/if}
